import { render } from "./CommunityCard.vue?vue&type=template&id=6e18e076&scoped=true"
import script from "./CommunityCard.vue?vue&type=script&lang=js"
export * from "./CommunityCard.vue?vue&type=script&lang=js"

import "./CommunityCard.vue?vue&type=style&index=0&id=6e18e076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e18e076"]])

export default __exports__